var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressFreeLove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.7429 24.7292L47.7426 24.7299C47.209 26.0349 45.7309 28.0697 43.7507 30.4316C41.7862 32.7749 39.3746 35.3862 37.0286 37.8295C34.6836 40.272 32.4087 42.5419 30.7198 44.2016C29.8754 45.0313 29.1778 45.7082 28.6914 46.1775C28.5116 46.351 28.3607 46.4961 28.2419 46.6101C28.1203 46.5147 27.9679 46.3944 27.7877 46.2512C27.2806 45.8479 26.5536 45.2623 25.6758 44.5341C23.9197 43.0773 21.5621 41.0516 19.1541 38.7745C16.7444 36.4959 14.2929 33.9738 12.3438 31.5238C10.3825 29.0586 8.97854 26.7254 8.58748 24.8191C7.58976 19.93 9.49242 14.5257 13.762 12.1232L13.5168 11.6875L13.762 12.1232C15.9191 10.9095 18.6769 10.3424 21.2442 10.8232C23.7932 11.3007 26.1662 12.8109 27.6123 15.7913L27.9937 16.5776L28.4782 15.8503C31.0146 12.0424 34.5141 11.1173 37.4144 11.1413C38.8706 11.1533 40.171 11.4059 41.1088 11.6567C41.5768 11.7819 41.9523 11.9061 42.209 11.9981C42.3373 12.0442 42.4358 12.0821 42.5011 12.1081C42.5327 12.1207 42.5566 12.1305 42.5723 12.137C44.709 13.3471 46.4705 15.3688 47.4619 17.6611C48.4568 19.9611 48.6609 22.4938 47.7429 24.7292Z",
    fill: "#FDC031",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.029 43.2537C19.8505 38.9005 10.4494 30.3659 9.31465 24.8435C8.33809 20.057 10.1812 14.7065 14.4382 12.3132",
    stroke: "#FDC031",
    strokeWidth: 2.94737,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.5442 15.0092C41.5551 15.2086 42.4698 15.8344 43.0269 16.7009C43.5839 17.5675 43.7765 18.6541 43.5426 19.6581",
    stroke: "#FDC031",
    strokeWidth: 2.94737,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressFreeLove);
export default __webpack_public_path__ + "static/media/stressFreeLove.2795dd2fc7312fc33f17f2620ec0798f.svg";
export { ForwardRef as ReactComponent };